import { useTranslation } from "react-i18next";
import TabsComponent from "../../../../components/tabs/TabsComponent";
import { ReceivedTab } from "./ReceivedTab";
import { OutGoingTab } from "./OutGoingTab";
import RequestsModel from "../../../../api/models/RequestsModel";
import { makeApiRequest, showApiErrorMessages } from "../../../../helpers";
import { showApologizeRequests } from "../../../../api/endpoints/tutors/requests";
import { ApiResponse } from "../../../../api/apiResponse";
import { useEffect, useState } from "react";

export default function RequestsInfo() {
  const LocalBasePath = "page.tutor.dashboard.requests";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [requestsReceived, setRequestsReceived] = useState<RequestsModel[]>([]);
  const [requests, setRequests] = useState<RequestsModel[]>([]);

  const [requestsNotPending, setRequestsNotPending] = useState<RequestsModel[]>(
    []
  );
  const showRequests = async () => {
    await makeApiRequest(
      () =>
        showApologizeRequests({
          filters: { sender_type: "Tutor" },
          orderBy: "-created_at" 
        }),
      (response: ApiResponse) => {
        if (response.isSuccess) {
          const { data } = response;
          const requestsList: RequestsModel[] = RequestsModel.fromApiResponse(
            data,
            "sender"
          );
          setRequests(requestsList);
        } else {
          showApiErrorMessages(response);
        }
      }
    );
  };
  const showReceivedRequests = async () => {
    await makeApiRequest(
      () =>
        showApologizeRequests({
          filters: {
            sender_type: "Student",
            is_new_student: false,
          },
          orderBy: "-created_at",
        }),
      (response: ApiResponse) => {
        if (response.isSuccess) {
          const { data } = response;
          const requestsList: RequestsModel[] =
            RequestsModel.fromApiResponsePending(data, "receiver");
          const requestWithoutPending =
            RequestsModel.fromApiResponseWithoutPending(data, "receiver");
          setRequestsReceived(requestsList);
          setRequestsNotPending(requestWithoutPending);
        } else {
          showApiErrorMessages(response);
        }
      }
    );
  };
  useEffect(() => {
    showRequests();
    showReceivedRequests();
  }, []);
  const tabs = [
    {
      name: t("received"),
      content: (
        <ReceivedTab
          requests={requestsReceived}
          requestsNotPending={requestsNotPending}
        />
      ),
      counter: requestsReceived.length,
    },
    {
      name: t("outgoing"),
      content: <OutGoingTab requests={requests} />,
      counter: requests.length,
    },
  ];
  return (
    <div className="flex flex-col w-full bg-gray-50 ">
      <div>
        <h1 className="px-8 mt-2 mb-4 text-2xl font-semibold text-gray-900 ">
          {t("apologizeSession")}
        </h1>
      </div>
      <TabsComponent requests={true} tabs={tabs} />
    </div>
  );
}
